export default {
  type: 'CURRENT_DASHBOARD',
  name: 'CURRENT_DASHBOARD',
  save: { fields: [], key: ['fields', 'that', 'dont', 'exists'] },
  load: { key: 'nodeId' },
  form: { submitLabel: 'Load Dashboard', schema: [] }
}
